import { IAppState } from '../../common/state';
import { EMetroTravelType } from '../../json_query';

export function selectTravelType(state: IAppState): EMetroTravelType {
  return (state.filters.jsonQuery.only_foot && state.filters.jsonQuery.only_foot.value) || EMetroTravelType.Any;
}
